import { render } from "./recruitNew.vue?vue&type=template&id=638a9598&scoped=true"
import script from "./recruitNew.vue?vue&type=script&lang=js"
export * from "./recruitNew.vue?vue&type=script&lang=js"

import "./recruitNew.vue?vue&type=style&index=0&id=638a9598&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638a9598"]])

export default __exports__